<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="工作台" 
				left-text="返回" 
				left-arrow 
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<div class="projectItem">
			<div class="itemRow">
				<div class="label">工作控制号</div>
				<div class="value">{{this.project.workNo}}</div>
			</div>
			<div class="itemRow">
				<div class="label">项目名称</div>
				<div class="value">{{this.project.projectName}}</div>
			</div>
			<div class="itemRow">
				<div class="label">委托方</div>
				<div class="value">{{this.project.projectEntrust}}</div>
			</div>
		</div>
		<div class="projectItem">
			<div class="itemTitle isBgGreen">质量</div>
			<van-row class="workList" gutter="20">
				<van-col span="8">
					<van-badge @badge-size="20">
						<a class="workItem isBgOrange" @click="checkPermisionJump('information:look:1','/qualityInspectionList')" href="#">报验</a>
						<template v-if="infoCount.qualityProblemState > 0" #content>
							<div class="badgeNum">{{infoCount.qualityProblemState}}</div>
						</template>
					</van-badge>
				</van-col>
				<van-col span="8">
					<van-badge>
						<a class="workItem isBgBlue" @click="checkPermisionJump('patrol:look:1','/qualityPatrolList')" href="#">巡检</a>
						<template v-if="infoCount.qualityProblemSource > 0" #content>{{infoCount.qualityProblemSource}}</template>
					</van-badge>
				</van-col>
				<van-col span="8">
					<van-badge>
						<a class="workItem isBgRed" @click="checkPermisionJump('station:search:1','/qualitySideStationList')" href="#">旁站</a>
						<!-- <template #content></template> -->
					</van-badge>
				</van-col>
			</van-row>
		</div>
		<div class="projectItem">
			<div class="itemTitle isBgBlue">安全</div>
			<van-row class="workList" gutter="20">
				<van-col span="8">
					<van-badge @badge-size="20">
						<a class="workItem isBgOrange" @click="checkPermisionJump('information:look:2','/safeInspectionList')" href="#">报验</a>
						<template v-if="infoCount.safeProblemState > 0" #content>
							<div class="badgeNum">{{infoCount.safeProblemState}}</div>
						</template>
					</van-badge>
				</van-col>
				<van-col span="8">
					<van-badge>
						<a class="workItem isBgBlue" @click="checkPermisionJump('patrol:look:2','/safePatrolList')" href="#">巡检</a>
						<template v-if="infoCount.safeProblemSource > 0" #content>{{infoCount.safeProblemSource}}</template>
					</van-badge>
				</van-col>
				<van-col span="8">
					<van-badge>
						<a class="workItem isBgRed" @click="checkPermisionJump('station:search:2','/safeSideStationList')" href="#">旁站</a>
						<!-- <template #content></template> -->
					</van-badge>
				</van-col>
			</van-row>
		</div>
		<div class="projectItem">
			<div class="itemTitle isBgBluish">日常</div>
			<van-row class="workList" gutter="20">
				<van-col span="8">
					<van-badge @badge-size="20">
						<a class="workItem isBgOrange" @click="checkPermisionJump('noteList:search','/notesList')" href="#">记事</a>
					</van-badge>
				</van-col>
				<van-col span="8">
				</van-col>
				<van-col span="8">
				</van-col>
			</van-row>
		</div>
		<div class="projectItem">
			<div class="itemTitle isBgOrange2">照片</div>
			<van-row class="workList" gutter="20">
				<van-col span="8">
					<van-badge @badge-size="20">
						<a class="workItem isBgOrange" @click="checkPermisionJump('qualityProgressPhoto:search:1','/photoList?photoType=1')" href="#">质量</a>
					</van-badge>
				</van-col>
				<van-col span="8">
					<van-badge>
						<a class="workItem isBgBlue" @click="checkPermisionJump('qualityProgressPhoto:search:2','/photoList?photoType=2')" href="#">进度</a>
					</van-badge>
				</van-col>
				<van-col span="8">
				</van-col>
			</van-row>
		</div>
	</div>
</template>

<script>
	import common from '../utils/common';
	import { Notify } from 'vant';
	import { projectInfoCount } from '@/api/project';
	export default {
		name: 'workbench',
		data() {
			return {
				project: {
					workNo: "",
					projectName: "",
					projectAddress: "",
					projectDetailedAddress: "",
					projectEntrust: "",
					projectDesignCompany: "",
					projectConstructionCompany: "",
					projectBeginTime: "",
					projectFinishTime: "",
					projectKind: "",
					contractCompany: ""
				},
				infoCount: {
					qualityProblemSource: 0,
					qualityProblemState: 0,
					qualityMonitor:0,
					safeProblemSource:0,
					safeProblemState:0,
					safeMonitor:0
				}
			}
		},
		mounted() {
			this.project = common.getProject();
			this.getProjectInfoCount();
		},
		created() {
		},
		methods: {
			checkPermisionJump(perm, jump){
				this.$router.push(jump);
			},
			goBack() {
				this.$router.push({
					name: 'projectList'
				});
			},
			getProjectInfoCount() {
				projectInfoCount(this.project.workNo).then(response => {
					if (response.data.resultCode === 200){
						this.infoCount = response.data.body;
					}
				})
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
